import React, { FC } from 'react';
import {
  Box,
  Center,
  HStack,
  IconButton,
  Text,
  VStack
} from '@chakra-ui/react';
import { ArrowUpDownIcon, CheckIcon } from '@chakra-ui/icons';
import { TokenSelector } from '@app/components/Swap/components/TokenSelector';
import { Currency } from '@cryptoalgebra/kim-sdk';
import { Token } from '@app/types/token';
import { InputsState } from '@app/screens/liquidity/AddLiquidityV3/hooks';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';

interface Props {
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
  handleFromTokenSelect: (token: Token) => void;
  handleToTokenSelect: (token: Token) => void;
  state: InputsState;
  handleFlip: () => void;
}

export const AddLiquidityTokensSelector: FC<Props> = ({
  currencyA,
  currencyB,
  handleFromTokenSelect,
  handleToTokenSelect,
  state,
  handleFlip
}) => {
  return (
    <VStack w="100%">
      <Box w="100%">
        <AddLiquiditySectionTitle
          label="Select a pair"
          isCompleted={!!(currencyA && currencyB)}
        />
        <HStack
          p={['24px 0', '24px 12px']}
          gap="12px"
          justifyContent="space-between"
        >
          <VStack alignItems="flex-start">
            <Text>Token 1</Text>
            <TokenSelector
              onSelect={handleFromTokenSelect}
              disabled={false}
              selected={state.from.token}
            />
          </VStack>
          <Center
            bg="neutral.700"
            color="neutral.100"
            sx={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              cursor: 'pointer'
            }}
            _hover={{ color: 'orange' }}
          >
            <IconButton aria-label="switch" onClick={handleFlip}>
              <ArrowUpDownIcon boxSize={4} transform="rotate(90deg)" />
            </IconButton>
          </Center>
          <VStack alignItems="flex-start">
            <Text>Token 2</Text>
            <TokenSelector
              onSelect={handleToTokenSelect}
              disabled={false}
              selected={state.to.token}
            />
          </VStack>
        </HStack>
      </Box>
    </VStack>
  );
};
